__turbopack_context__.v({
  "className": "utkeOq_className",
  "variable": "utkeOq_variable",
});
